import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CommonService } from '@/services/common/common.service';
import { Asset, Zone, VehicleType } from '@/interfaces/new-license-request/new-license-request-interfaces';
import { Option } from '@/shared/select-list/select-list.component';
import { SelectOption } from '@/shared/select/select.component.interface';

@Component({
  selector: 'app-form-location-and-equipment',
  templateUrl: './form-location-and-equipment.component.html',
  styleUrls: ['./form-location-and-equipment.component.css'],
})
export class FormLocationAndEquipmentComponent implements OnInit {

  assetList: SelectOption[] = [];
  zoneList: SelectOption[] = [];
  vehicleTypeList: SelectOption[] = [];

  @Input() formNumber: number = 2;

  @Input() controlForm = new FormGroup({
    assetId: new FormControl('', [Validators.required, Validators.min(1)]),
    zoneId: new FormControl('', [Validators.required, Validators.min(1)]),
    vehicleTypeId: new FormControl('', [Validators.required, Validators.min(1)]),
    patent: new FormControl('', [Validators.required]),
  });

  get vehicleTypeId(): FormControl {
    return this.controlForm.controls.vehicleTypeId as FormControl;
  }
  get assetId(): FormControl {
    return this.controlForm.controls.assetId as FormControl;
  }
  get zoneId(): FormControl {
    return this.controlForm.controls.zoneId as FormControl;
  }

  constructor(
    private commonService: CommonService,
  ) {
    this.getAssets();
  }

  ngOnInit() {
    this.controlForm.controls.assetId.valueChanges.subscribe({
      next: (assetId) => {
        if (assetId) {
          this.onSelectedAssetChange(assetId);
        }
        // this.controlForm.controls.zoneId.patchValue('');
        // this.controlForm.controls.vehicleTypeId.patchValue('');
        // this.controlForm.controls.patent.reset();
        this.controlForm.controls.zoneId.reset();
        this.controlForm.controls.vehicleTypeId.reset();
        this.controlForm.controls.patent.reset();
      },
    });

    this.controlForm.controls.patent.valueChanges.subscribe({
      next: (value) => {
        const numbersAndLettersRegexp = /[^\w]/gi;
        const underscoreRegexp = new RegExp('_', 'gi');
        let cleaned = value;
        if (numbersAndLettersRegexp.test(value)) {
          cleaned = value.replace(numbersAndLettersRegexp, '');
        }
        if (underscoreRegexp.test(value)) {
          cleaned = value.replace(underscoreRegexp, '');
        }
        if (cleaned !== value) {
          this.controlForm.controls.patent.patchValue(cleaned);
        }
      },
    });
  }

  getAssets() {
    this.commonService.getAllAssets().subscribe({
      next: (assets) => {
        this.assetList = assets.map(({ id, shortName }) => ({ id, value: shortName }));
      },
    });
  }

  getZoness(assetId: number) {
    this.commonService.getZonesByAsset(assetId).subscribe({
      next: (zones) => {
        this.zoneList = zones.map(({ id, name }) => ({ id, value: name }));
      },
    });
  }

  getVehicleTypes(assetId: number) {
    this.commonService.getVehiclesTypesByAsset(assetId).subscribe({
      next: (vehicleTypeList) => {
        this.vehicleTypeList = (<Required<VehicleType>[]>vehicleTypeList).map((vehicleType): SelectOption => ({ id: vehicleType.id, value: vehicleType.name }));
      },
    });
  }

  onSelectedAssetChange(assetId: number) {
    this.getVehicleTypes(assetId);
    this.getZoness(assetId);
  }

}
